import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <footer>
            <div className="container">
                <div className="footer-content">
                    <div className="footer-column">
                        <h3>Maa Saryu Agency</h3>
                        <p>Your trusted partner for premium tiles, granite, and sanitary solutions.</p>
                    </div>
                    <div className="footer-column">
                        <h3>Quick Links</h3>
                        <ul>
                            <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                            <li><Link to="/products" onClick={scrollToTop}>Products</Link></li>
                            <li><Link to="/gallery" onClick={scrollToTop}>Gallery</Link></li>
                            <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
                            <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h3>Products</h3>
                        <ul>
                            <li><Link to="/gallery" onClick={scrollToTop}>Tiles & Granite</Link></li>
                            <li><Link to="/gallery" onClick={scrollToTop}>CP Fittings</Link></li>
                            <li><Link to="/gallery" onClick={scrollToTop}>Bath Fittings</Link></li>
                            <li><Link to="/gallery" onClick={scrollToTop}>Sanitary Ware</Link></li>
                            <li><Link to="/gallery" onClick={scrollToTop}>Bath Accessories</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column footer-contact">
                        <h3>Contact Us</h3>
                        <div className="contact-info-grid">
                            <div className="contact-section">
                                <h4 className="contact-section-title">Maa Saryu Agency</h4>
                                <div className="contact-info-item">
                                    <span className="contact-icon">📍</span>
                                    <span className="contact-text">
                                        Ashapur Rd, Darshan Nagar<br />
                                        Devkali Bypass Road,<br />
                                        Ayodhya, Uttar Pradesh, 224135
                                    </span>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-icon">📞</span>
                                    <a href="tel:+917897239423" className="contact-link">+91 7897239423</a>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-icon">📞</span>
                                    <a href="tel:+919651245787" className="contact-link">+91 9651245787</a>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-icon">✉️</span>
                                    <a href="mailto:maasaryuagency@gmail.com" className="contact-link">maasaryuagency@gmail.com</a>
                                </div>
                            </div>
                            
                            <div className="contact-section">
                                <h4 className="contact-section-title contact-section-spaced">A S Home Solution</h4>
                                <div className="contact-info-item">
                                    <span className="contact-icon">🏪</span>
                                    <span className="contact-text">
                                        Bikapur, Station Road,<br />
                                        Ayodhya 224204<br />
                                        Uttar Pradesh
                                    </span>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-icon">📞</span>
                                    <a href="tel:+917897449423" className="contact-link">+91 7897449423</a>
                                </div>
                                <div className="contact-info-item">
                                    <span className="contact-icon">✉️</span>
                                    <a href="mailto:ashomesolution@gmail.com" className="contact-link">ashomesolution@gmail.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-column" style={{ flex: '1', minWidth: '250px' }}>
                        <h3>Follow Us</h3>
                        <ul className="footer-social-list">
                            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                <span style={{ 
                                    marginRight: '8px', 
                                    fontSize: '20px',
                                    color: '#1877f2',
                                    fontWeight: 'bold'
                                }}>f</span>
                                <a 
                                    href="https://www.facebook.com/profile.php?id=61558632194566" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        color: 'inherit', 
                                        textDecoration: 'none',
                                        transition: 'color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => (e.target as HTMLElement).style.color = '#1877f2'}
                                    onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'inherit'}
                                >
                                    Facebook
                                </a>
                            </li>
                            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                <span style={{ 
                                    marginRight: '8px', 
                                    fontSize: '16px',
                                    background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: 'bold'
                                }}>📷</span>
                                <a 
                                    href="https://instagram.com/maasaryuagency" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        color: 'inherit', 
                                        textDecoration: 'none',
                                        transition: 'color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => (e.target as HTMLElement).style.color = '#e4405f'}
                                    onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'inherit'}
                                >
                                    Instagram
                                </a>
                            </li>
                            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                <span style={{ 
                                    marginRight: '8px', 
                                    fontSize: '18px',
                                    color: '#25d366',
                                    fontWeight: 'bold'
                                }}>💬</span>
                                <a 
                                    href="https://wa.me/917897239423?text=Hello%20Maa%20Saryu%20Agency,%20I%20would%20like%20to%20inquire%20about%20your%20products." 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        color: 'inherit', 
                                        textDecoration: 'none',
                                        transition: 'color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => (e.target as HTMLElement).style.color = '#25d366'}
                                    onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'inherit'}
                                >
                                    WhatsApp
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="copyright">
                    <p>&copy; 2025 Maa Saryu Agency. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;